export default __webpack_public_path__ + "static/broderie4.inspirations-f04952f6e77e4c02afef491dc82156dd.jpg";